import { Path } from '@/main/router/routerPath';

import Edit from './Edit.vue';
import List from './List.vue';
import { NAME, CRUMB_LABEL_LIST, CRUMB_LABEL_EDIT } from './constants';

export const router = new Path().addChildren([
	new Path(NAME, { List }, CRUMB_LABEL_LIST),
	new Path(NAME, { SelectList: List }, CRUMB_LABEL_LIST),
	new Path(NAME, { Edit }, CRUMB_LABEL_EDIT),
]);
